import ReactHtmlParser, { domToReact } from 'html-react-parser';
import { Link } from "react-router-dom";
import { string } from 'prop-types';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';

HtmlParser.propTypes = {
  content: string
};

function HtmlParser(props) {
  const { content } = props;

  let childrens = [];
  function getChild(data, index) {
    if (data.data) {
      childrens.push(data.data);
    }

    if (data.children) {
      data.children.forEach(c => {
        if (c.data) {
          const body = `<${c.parent.name}>${c.data}</${c.parent.name}>`
          childrens.push(body);
        } else {
          getChild(c, index)
          childrens[index] = `<${c.parent.name}>${childrens[index]}</${c.parent.name}>`;
        }
      });
    }
  }

  function getString(data) {
    data.children.forEach((c, i) => {
      getChild(c, i);
    });
    const body = [...childrens];
    childrens = [];
    return body.join('\n');
  }

  return (
    <div>
      {ReactHtmlParser(content, {
        replace: (domNode) => {
          const { attribs, name } = domNode;
          if (name === 'table') {
            return (
              <div className="table-wrap">
                <table>{domToReact(domNode.children)}</table>
              </div>
            );
          }

          if (name === 'div' && attribs.class == 'highlighter' ) {
            const data = getString(domNode);
            return (
              <SyntaxHighlighter language={attribs.language} style={prism}>
                {data}
              </SyntaxHighlighter>
            )
          }

          if (name && name === 'a') {
            const isInnerLink = attribs.href ? attribs.href.indexOf('{env}') : -1;
            const isDownloadLink = attribs.href ? attribs.href.indexOf('{env-download}') : -1;

            //create a redirect link without reloading the page
            if (isInnerLink !== -1) {
              const linkLength = attribs.href.length;
              const href = attribs.href.substring(13, linkLength);
              const children = domNode.children[0].data;

              return (
                <Link to={href} className="inner-link">
                  {children}
                </Link>
              );
            }

            //create a link to download the file
            if (isDownloadLink !== -1) {
              const hostname = window.location.hostname;
              const href = attribs.href.replace('{env-download}', hostname);
              const children = domNode.children[0].data;

              return (
                <a href={href} className="inner-link" download>
                  {children}
                </a>
              );
            }
          }
        },
      })}
    </div>
  );
}

export default HtmlParser;
